import {
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonSpinner,
  IonCard,
  IonFooter,
  IonButtons,
  IonToolbar,
} from "@ionic/react";
import {useMemo, useRef} from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { User } from "../../../@types/user";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { createUser } from "../../../store/userCreate/actions/createUser";
import { selectUserCreateStatus } from "../../../store/userCreate/selectors/selectUserCreateStatus";
import { validate, format } from "rut.js";
import { selectUser } from "../../../store/userAuthentication/selectors/selectUser";

export const UserCreateForm: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const createStatus = useSelector(selectUserCreateStatus);
  const formSubmit = useRef<any>(null);
  const user = useSelector(selectUser);


  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      dni: "",
      sourceOrganization: user?.sourceOrganization,
    },
  });

  const onSubmit = async (data: User) => {
    try {
      const { payload: userCreated }: any = await dispatch(createUser(data));
      if (userCreated) {
        history.replace(`/app/rrhh/usuarios/${userCreated.id}`);
      }
    } catch (error) {}
  };

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        placeholder="Ej. John Doe"
        value={value}
        onIonChange={({ detail: { value } }) => onChange(value)}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      />
    ),({ field: { onChange, value } }:any) => (
      <IonInput
        value={value}
        type="email"
        placeholder="Ej. micorreo@gmail.com"
        onIonChange={({ detail: { value } }) => onChange(value)}
        {...register("email", {
          required: "Campo obligatorio.",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Por favor, verifique el email.",
          },
        })}
      />
    ),({ field: { onChange, value } }:any) => (
      <IonInput
        value={value}
        placeholder="Ej. 12.345.678-9"
        type="text"
        {...register("dni", {
          required: "Campo obligatorio.",
          validate: {
            rut: (value) => validate(value),
          },
        })}
        onIonChange={({ detail: { value } }) => onChange(format(value!))}
      />
    )]
  },[])

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <IonCard style={{ maxWidth: 700 }}>
        <br />
        <IonItem lines="inset">
          <IonLabel position="stacked">Nombre</IonLabel>
          <Controller
            name="name"
            control={control}
            render={controllers[0]}
          />
        </IonItem>
        {errors.name && (
          <IonItem lines="none">
            <InputErrorMessage errorMessage={errors.name?.message || ""} />
          </IonItem>
        )}

        <IonItem lines="inset">
          <IonLabel position="stacked">Email</IonLabel>
          <Controller
            name="email"
            control={control}
            render={controllers[1]}
          />
        </IonItem>

        {errors.email && (
          <IonItem lines="none">
            <InputErrorMessage errorMessage={errors.email?.message || ""} />
          </IonItem>
        )}

        <IonItem lines="inset">
          <IonLabel position="stacked">Rut</IonLabel>
          <Controller
            name="dni"
            control={control}
            render={controllers[2]}
          />
        </IonItem>
        {errors.dni && (
          <IonItem lines="none">
            <InputErrorMessage errorMessage={errors.dni?.message || "RUT inválido"} />
          </IonItem>
        )}

        <br />
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton
                ref={formSubmit}
                fill="solid"
                type="submit"
                disabled={createStatus === "pending"}
              >
                {createStatus === "pending" ? (
                  <>
                    <IonSpinner />
                    <span className="ion-margin-left">Creando usuario</span>
                  </>
                ) : (
                  <>Crear usuario</>
                )}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonCard>
    </form>
  );
};
